import { api, buildQueryParams, URLs } from '@/libs/api'
import type {
  ApiResponse,
  UpdateProfilePicPayload,
  UploadListData,
  UploadListParams,
  UploadPayload,
} from '@/libs/interfaces'

export const uploadsApi = {
  upload: async (payload: UploadPayload): Promise<void> => {
    const { orgID, file, entity, entityID, fileType, fileName, profilePic } = payload
    const formData = new FormData()
    formData.append('file', file)
    formData.append('entity', entity)
    formData.append('entityID', entityID)
    formData.append('fileType', fileType)
    formData.append('fileName', fileName)
    formData.append('profilePic', String(profilePic))
    await api.post<void>(URLs.Uploads.create(orgID), formData)
  },

  list: async (params: UploadListParams): Promise<UploadListData> => {
    const { orgID, ...queryParams } = params
    const query = buildQueryParams(queryParams)
    return await api
      .get<ApiResponse<UploadListData>>(URLs.Uploads.list(orgID, query))
      .then((response) => response.data.data)
  },

  getPreSignedUrl: async (params: { orgID: string; uploadID: string }): Promise<string> => {
    return await api
      .get<ApiResponse<{ preSignedUrl: string }>>(URLs.Uploads.byID(params.orgID, params.uploadID))
      .then((response) => response.data.data.preSignedUrl)
  },

  delete: async (params: { orgID: string; uploadID: string }): Promise<{ uploadID: string }> => {
    return await api
      .delete<ApiResponse<{ uploadID: string }>>(URLs.Uploads.byID(params.orgID, params.uploadID))
      .then((response) => response.data.data)
  },

  updateProfilePic: async (
    payload: UpdateProfilePicPayload,
  ): Promise<{ uploadID: string; profilePic: boolean }> => {
    const { orgID, uploadID, ...body } = payload
    return await api
      .patch<
        ApiResponse<{ uploadID: string; profilePic: boolean }>
      >(URLs.Uploads.profilePic(orgID, uploadID), body)
      .then((response) => response.data.data)
  },
}
